import React from 'react';

import GlobalTooltip from 'components/GlobalTooltip';
import ResizableDataTable from 'components/ResizableDataTable/ResizableDataTable';
import useIsMobileView from 'hooks/useIsMobileView';
import CaseTemplate from 'modules/file_manager/components/FileManagerView/ListView/Templates/CaseTemplate';
import { useUserDetailsContext } from 'context/userDetailsContext';
import { convertToSpecificTimeZoneFormat } from 'utils/utility_functions/timezone';

export default function Table(props) {
  const { list, paginatorTemplate, pageSize, setSelectedInstanceData } = props || {};
  const isMobileView = useIsMobileView();
  const { userDetails } = useUserDetailsContext();

  const instanceStoppedTimeTemplate = (rowData) => {
    const instanceStoppedTime = convertToSpecificTimeZoneFormat(rowData?.instance_stop_time, userDetails?.timezone) || 'N/A';
    return (
      <>
        <span className="p-column-title text-break">Instance Stopped Time</span>
        <span title={instanceStoppedTime || undefined}>{instanceStoppedTime}</span>
      </>
    );
  };

  const statusTemplate = (rowData) => {
    return (
      <>
        <span className="p-column-title text-break">Status</span>
        <GlobalTooltip tooltip="View Status" position="top">
          <button className="run-btn-automation text-nowrap" onClick={() => setSelectedInstanceData({ ...rowData, action: 'view' })}>
            View
          </button>
        </GlobalTooltip>
      </>
    );
  };

  //This template can be used in future if any requirements are there
  const actionTemplate = (rowData) => {
    const isActive = rowData?.automation_status !== 'INACTIVE';

    return (
      <>
        <span className="p-column-title text-break">Actions</span>
        <span className="d-inline-table">
          <div className="d-flex align-items-center">
            <GlobalTooltip tooltip={isActive ? 'Run' : 'Automation is inactive'} position="top">
              <button
                className="run-btn-automation text-nowrap"
                onClick={() => setSelectedInstanceData({ ...rowData, action: 'run' })}
                disabled={!isActive}
              >
                Run
              </button>
            </GlobalTooltip>
          </div>
        </span>
      </>
    );
  };

  return (
    <ResizableDataTable
      value={list}
      paginator
      paginatorTemplate={paginatorTemplate}
      rows={pageSize}
      className="p-datatable-responsive"
      storageKey="column_widths_automation_stopped_instances_list"
      stripedRows
      columns={[
        {
          header: 'Case/Lead Name',
          field: 'case_name',
          body: (rowData) => <CaseTemplate rowData={rowData} />,
          sortable: true,
        },
        {
          header: 'Instance Stopped Time',
          field: 'instance_stop_time',
          body: instanceStoppedTimeTemplate,
          sortable: true,
        },
        {
          header: 'Instance Status',
          field: 'status',
          body: statusTemplate,
          sortable: false,
          className: 'ellipsis-text',
          style: isMobileView ? {} : { textAlign: 'center' },
        },
        {
          header: 'Actions',
          field: 'action',
          body: actionTemplate,
          sortable: false,
          fixed: true,
          className: 'action-automation-list',
          resizable: false,
          style: isMobileView ? {} : { textAlign: 'center' },
        },
      ]}
    />
  );
}
